'use client';

import { ImgItem } from "@/types";
import Image from "next/image";

const gallery: ImgItem[] = [
  { url: '/images/gallery/1_800.png', alt: 'Gallery Image 1' },
  { url: '/images/gallery/2_800.png', alt: 'Gallery Image 2' },
  { url: '/images/gallery/3_800.png', alt: 'Gallery Image 3' },
  { url: '/images/gallery/4_800.png', alt: 'Gallery Image 4' },
  { url: '/images/gallery/5_800.png', alt: 'Gallery Image 5' },
  { url: '/images/gallery/6_800.png', alt: 'Gallery Image 6' },
  { url: '/images/gallery/7_800.png', alt: 'Gallery Image 7' },
  { url: '/images/gallery/8_800.png', alt: 'Gallery Image 8' },
  { url: '/images/gallery/9_800.png', alt: 'Gallery Image 9' },
  { url: '/images/gallery/10_800.png', alt: 'Gallery Image 10' },
  { url: '/images/gallery/11_800.png', alt: 'Gallery Image 11' },
  { url: '/images/gallery/12_800.png', alt: 'Gallery Image 12' },
  { url: '/images/gallery/13_800.png', alt: 'Gallery Image 13' },
  { url: '/images/gallery/14_800.png', alt: 'Gallery Image 14' },
];

export default function GallerySection() {
  return (
    <section className="gallery-section">
      <div className="fence">
        {gallery.map((img: ImgItem, i: number) => (
          <figure key={i} className="card" aria-label="Image">
            <Image
              src={img.url}
              alt={img.alt}
              width={600}
              height={900}
              loading="lazy"
              decoding="async"
              style={{
                width: "100%",
                height: "100%",
                display: "block",
                objectFit: "cover",
              }}
            />
          </figure>
        ))}
      </div>

      <style jsx>{`
        .fence {
          --gap: 8px;
          --cols: 2;

          display: flex;
          flex-wrap: wrap;
          gap: var(--gap);
          justify-content: flex-start;
        }
        .card {
          margin: 0;
          overflow: hidden;
          border-radius: 12px;
          background: #f6f6f6;

          /* ширина = (100% - gaps) / cols */
          width: calc((100% - (var(--cols) - 1) * var(--gap)) / var(--cols));
          aspect-ratio: 3 / 4;
        }
        @media (min-width: 640px) {
          .fence { --cols: 3; }
        }
        @media (min-width: 900px) {
          .fence { --cols: 4; }
        }
        @media (min-width: 1100px) {
          .fence { --cols: 5; }
        }
        @media (min-width: 1400px) {
          .fence { --cols: 6; }
        }
        @media (min-width: 1700px) {
          .fence { --cols: 7; }
        }
        .card :global(img) {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }
      `}</style>
    </section>
  );
}
